import { UISref } from "@uirouter/react";
import styled from "styled-components";
import { PrimaryButton } from "../../../../components/button";
import { NoElements } from "../../../../components/no-elements";
import { FraudRoutes } from "../../routes";

const CTA = styled(PrimaryButton)`
  width: 20em;
`;

export const NoBusinessAml = () => (
  <NoElements item="AMLs">
    <UISref to={FraudRoutes.names.newBusinessKyb}>
      <a>
        <CTA variant="contained">Run a Business AML report</CTA>
      </a>
    </UISref>
  </NoElements>
);
